import React from 'react';
import { useFormikContext } from 'formik';
import WrapperFormikField from './WrapperFormikField';
import styles from './ErrorMessagesShared.module.css';

export default function CheckField({ onChange = () => {}, ...restOfProps }) {
  const { setFieldValue } = useFormikContext();
  const handleChange = (value) => {
    onChange(value);
    setFieldValue(restOfProps.name, value.target.checked);
  };

  return (
    <WrapperFormikField {...restOfProps}>
      {({ currentValue, errorField }) => (
        <>
          <input type="checkbox" {...restOfProps} onChange={handleChange} checked={currentValue} />
          {errorField && <div className={styles.feedbackErrorMessages}>{errorField}</div>}
        </>
      )}
    </WrapperFormikField>
  );
}
